// @flow
import { differenceInCalendarDays, setDate, subMonths } from 'date-fns';

const formatExpirationDate = (expirationDate: ?string): string => {
  if (!expirationDate) return '';
  return `${expirationDate.slice(0, 2)}/${expirationDate.slice(2)}`;
};

const formatCreditCardNumber = (creditCardNumber: ?string): string => {
  if (!creditCardNumber) return '';
  return `${creditCardNumber.slice(0, 4)} XXXX XXXX ${creditCardNumber.slice(12)}`;
};

const formatCardType = (type: ?string): ?string => {
  if (!type) return null;
  const map = {
    Visa: 'visa',
    MasterCard: 'master-card',
    'American Express': 'american-express',
    'Diners Club': '',
    Discover: 'discover',
    JCB: 'jcb',
    'China UnionPay': 'unionpay',
    Maestro: 'maestro',
  };
  return map[type] || null;
};

export const paymentMeanValidityStatus = (
  endDateTime: number,
  expirationDate: string
): 'VALID' | 'EXPIRED' | 'DELETED' => {
  const formatedCardEndDateTime = setDate(endDateTime, 1);

  const [expirationDateMonth, expirationDateYear] = expirationDate.split('/');
  const formatedExpirationDate = subMonths(
    new Date(Date.UTC(Number(expirationDateYear), Number(expirationDateMonth))),
    1
  );

  if (endDateTime > new Date().valueOf()) {
    return 'VALID';
  }

  const differenceInDays = differenceInCalendarDays(formatedCardEndDateTime, formatedExpirationDate);
  if (differenceInDays !== 0) {
    return 'DELETED';
  }
  return 'EXPIRED';
};

export const formatPaymentMeanInfo = (
  paymentMeanCharacteristics: PaymentMeanCharacteristicsType
): PaymentMeanCharacteristicsType => ({
  ...paymentMeanCharacteristics,
  cardNumber: formatCreditCardNumber(paymentMeanCharacteristics.cardNumber),
  expirationDate: formatExpirationDate(paymentMeanCharacteristics.expirationDate),
  cardType: formatCardType(paymentMeanCharacteristics.cardType),
});

type PaymentMeanCharacteristicsType = {
  type: 'PAYPAL' | 'CREDIT_CARD',
  cardType?: ?string,
  cardNumber: string,
  expirationDate: string,
  holder: string,
};
